<script setup lang="ts">
import {watch, toRef} from 'vue';
import {useForm} from 'vee-validate';
import * as yup from 'yup';
import BaseConfirm from '@/components/common/popup/BaseConfirm.vue';
import VeeInput from '@/components/VeeInput.vue';

// props, context, emits, libs
const emits = defineEmits(['submit', 'close']);
const props = defineProps({
    isOpen: {type: Boolean, required: true},
});

const schema = yup.object({
    password: yup
        .string()
        .required('비밀번호를 입력해주세요.')
        .min(8, '8자 이상 입력해주세요.'),
});

const {values, setErrors, meta} = useForm({
    validationSchema: schema,
    validateOnMount: false,
});

// ref, reactive
const isOpen = toRef(props, 'isOpen');

// computed
// methods
const handleAccept = async () => {
    if (!values.password) {
        setErrors({password: '비밀번호를 입력해주세요.'});
        return;
    }

    if (meta.value.valid) {
        // NOTE: 호출하는 API가 다름으로 로직처리는 밖에서 한다.
        emits('submit', values.password, setErrors);
    }
};
// effect (created, mounted, watch, VueUse)
watch([isOpen], () => {
    if (isOpen.value) {
        setErrors({password: ''});
    }
});
</script>
<template>
    <base-confirm
        :is-open="isOpen"
        :title="'2차 인증'"
        :buttons-position="'center'"
        :ignore-backdrop-click="true"
        :is-content-type="true"
        :cancel-text="'취소'"
        @accept="handleAccept"
        @cancel="emits('close')"
        style="width: 400px"
    >
        <div class="base-confirm-description">
            <div class="verification-description">
                개인정보 보호를 위해 로그인 시 입력하신 비밀번호를 다시
                입력해주세요.
            </div>
            <vee-input
                class="form-input"
                :type="'password'"
                :name="'password'"
                :placeholder="'비밀번호 입력'"
                autocomplete="current-password"
            />
        </div>
    </base-confirm>
</template>
<style scoped lang="scss">
.verification-description {
    padding: 16px 0;
    display: block;
    font-size: 16px;
    font-weight: 600;
    color: #707070;
    line-height: 20px;
}

.base-confirm-description {
    margin-bottom: -19px;
}
</style>
